import React, { useEffect } from 'react';
import classes from './Home12Download.module.scss';
import { Link } from 'react-router-dom';
import Home12Header from './Home12Header';

const Home12ThankYou = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={classes.root}>
            <Home12Header mode="fixed" />

            <main className={classes.mainContent}>
                <div className={classes.container}>
                    <div className={classes.formWrapper}>
                        <div className={classes.successMessage}>
                            <div className={classes.successIcon}>✓</div>
                            <h2>Thank You</h2>
                            <p>
                                お問い合わせを受け付けました。<br />
                                内容を確認の上、担当者より通常1〜2営業日以内にご連絡いたします。
                            </p>
                            <div className={classes.submitAction}>
                                <Link to="/" className={classes.backBtn}>トップページへ戻る</Link>
                            </div>
                        </div>
                    </div>

                    <div className={classes.infoWrapper}>
                        <div className={classes.documentPreview}>
                            <img src="/react-assets/home10/home10-feature-support.jpg" alt="Thank you visual" className={classes.previewImage} />
                            <div className={classes.previewOverlay}>
                                <h3>お問い合わせ受付完了</h3>
                                <ul>
                                    <li>- 担当者が内容を確認します</li>
                                    <li>- 通常1〜2営業日でご連絡します</li>
                                    <li>- お急ぎの際はお電話でも対応可能です</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <footer className={classes.footer}>
                <div className={classes.footerLinks}>
                    <Link to="/privacy">プライバシーポリシー</Link>
                </div>
                <div className={classes.companyInfo}>
                    <p>&copy; {new Date().getFullYear()} collabo Inc.</p>
                </div>
            </footer>
        </div>
    );
};

export default Home12ThankYou;
